import { useQuery } from "@tanstack/react-query";
import { creditQueries } from "@/api/credits";

/**
 * Hook to fetch and track an agent's credit balance
 *
 * @param agentId - The ID of the agent to fetch credits for
 * @returns Object containing credits, loading state, error, and refetch function
 */
export function useAgentCreditBalance(agentId: string | undefined) {
  const {
    data: balance,
    isLoading,
    error,
    refetch,
  } = useQuery({
    ...creditQueries.agentBalance(agentId || ""),
    enabled: !!agentId,
  });

  return {
    credits: balance?.available_credits || 0,
    isLoading,
    error,
    refetchCredits: refetch,
  };
}
